import { useMutation } from "@tanstack/react-query";
import usePrivateAxios from "@/common/api/usePrivateAxios";
import { ErrorResponse } from "@/common/types/errorResponse";

interface UseMarkAsWinnerRaffleProps {
  id?: string;
  onSuccess?: () => void;
  onError?: (error: ErrorResponse) => void
}

const useMarkAsWinnerRaffle = ({ id, onSuccess, onError }: UseMarkAsWinnerRaffleProps) => {
  const privateAxios = usePrivateAxios();
  return useMutation({
    mutationKey: ['markAsWinnerRaffle', id],
    mutationFn: async () => {
      return privateAxios.put(`/tmais/reward_tickets/${id}/mark_as_winner`);
    },
    onSuccess,
    onError,
  });
};

export default useMarkAsWinnerRaffle;
